
/**
 * 강의 콘텐츠 유형
 */
export type CourseResponseSectionsItemLecturesItemContentType = typeof CourseResponseSectionsItemLecturesItemContentType[keyof typeof CourseResponseSectionsItemLecturesItemContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseResponseSectionsItemLecturesItemContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  VIDEO_MARKDOWN: 'VIDEO_MARKDOWN',
  QUIZ: 'QUIZ',
  EXTERNAL_LINK: 'EXTERNAL_LINK',
  TEXT: 'TEXT',
  CODING: 'CODING',
} as const;
